// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-page .error-container {
  margin: 0 auto;
  padding: 192px 96px;
  text-align: center;
}
.error-page .error-container img {
  width: 916px;
  height: auto;
  margin-bottom: 16px;
}
.error-page .error-container h1 {
  font-size: 48px;
  color: #FF4E35;
  font-weight: 600;
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./node_modules/.pnpm/@nackle+studio-tools@1.9.9_@types+react@18.3.12_antd@5.24.6_date-fns@2.30.0_moment@2.30.1_rea_phmwef3nwavhog6egt6kd254om/node_modules/@nackle/studio-tools/dist/components/app-error/app-error.less"],"names":[],"mappings":"AAAA;EAEQ,cAAA;EACA,mBAAA;EACA,kBAAA;AAAR;AAJA;EAOY,YAAA;EACA,YAAA;EACA,mBAAA;AAAZ;AATA;EAYY,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAAZ","sourcesContent":[".error-page{\n    .error-container {\n        margin: 0 auto;\n        padding: 192px 96px;\n        text-align: center;\n\n        img {\n            width: 916px;\n            height: auto;\n            margin-bottom: 16px;\n        }\n        h1 {\n            font-size: 48px;\n            color: #FF4E35;\n            font-weight: 600;\n            margin-bottom: .0;\n        }\n    }\n}\n@error-color: #EB0004;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
